<!-- 材料上传 -->
<template>
  <div class="el-materialUpload">
    <el-row class="page_content">
      <h1 class="head_title">材料上传</h1>
      <div style="width: 1000px;margin: 0 auto">
        <template v-for="(item,index) in attributeList">
          <div style="margin-bottom: 20px;border: 1px solid rgb(230 230 231);padding: 20px;box-shadow: 1px 2px 4px rgb(230 230 231);border-radius: 10px;">
            <el-row style="padding-bottom:20px;" :key="index+'attributeList'">
              <span class="title_l">
                <span style="color:red;" v-if="item.notNullStatus == 1">*</span>
                {{item.attributeName}}：
              </span>
              <span style="float:left;margin-right:20px;" v-if="item.inputType == 6 || item.inputType == 5">
                <el-upload
                  class="avatar-uploader"
                  :action="uploadUrl"
                  :headers="headers"
                  :show-file-list="false"
                  :on-success="(res, file) => {attributeSuccess(item, res, file)}"
                  :disabled="studentNewDataState == 1"
                  :before-upload="item.inputType==5 ? beforeAvatarUpload : null">
                  <template v-if="item.inputType==5">
                    <img v-if="!$isEmpty(attributeRelationMap[item.attributeId])" :src="$isHttp(attributeRelationMap[item.attributeId])" class="attrList_avatar">
                  </template>
                  <template v-if="item.inputType==6">
                    <img v-if="!$isEmpty(attributeRelationMap[item.attributeId])" :src="filePng" class="attrList_avatar">
                  </template>
                  <i v-if="$isEmpty(attributeRelationMap[item.attributeId])" class="el-icon-plus attrList-uploader-icon" title="点击上传"></i>
                </el-upload>
              </span>
              <!-- 签名 -->
              <span style="float:left;margin-right:20px;" v-if="item.inputType == 9">
                <div style="border: 1px dashed #d9d9d9;width: 200px;height: 100px;">
                  <img v-if="!$isEmpty(attributeRelationMap[item.attributeId])" :src="$isHttp(attributeRelationMap[item.attributeId])" class="attrList_avatar">
                </div>
              </span>
              <span style="float:left;margin-right:20px;">
                <el-button
                  type="primary"
                  size="small"
                  @click="previewImg(attributeRelationMap[item.attributeId])"
                  v-if="!$isEmpty(attributeRelationMap[item.attributeId]) && (item.inputType == 5 || item.inputType == 9)">
                  预览
                </el-button>
                <el-button
                  type="success"
                  size="small"
                  @click="cropper_cj(attributeRelationMap[item.attributeId], item.attributeId)"
                  v-if="!$isEmpty(attributeRelationMap[item.attributeId]) && item.inputType == 5">
                  裁剪
                </el-button>
                <el-button
                  type="primary"
                  size="small"
                  @click="$downLoadFile(attributeRelationMap[item.attributeId], item.attributeName+'附件')"
                  v-if="!$isEmpty(attributeRelationMap[item.attributeId]) && item.inputType == 6">
                  下载
                </el-button>
                <el-button
                  type="primary"
                  size="small"
                  @click="singShow(attributeRelationMap[item.attributeId], item.attributeId)"
                  v-if="item.inputType == 9">
                  立即签名
                </el-button>
              </span>
            </el-row>
            <el-row>
              <span class="title_l">描述：</span>
              <span style="float:left;margin-right:20px;width: 550px;color: #8c939d;">
                {{item.attributeValues}}
              </span>
            </el-row>
          </div>
        </template>
        <template v-if="attributeList.length <= 0">
          <el-empty description="暂无数据"></el-empty>
        </template>

        <!-- 审核状态显示 -->
        <div v-if="studentNewDataState != null && studentNewDataState != 2" style="margin-top: 30px;">
          <div style="padding: 20px;background-color: #f0f9ff;border-radius: 4px;border-left: 4px solid #409EFF;">
            <el-row style="margin-bottom: 10px;">
              <span style="font-weight: bold;font-size: 16px;">审核状态：</span>
              <el-tag v-if="studentNewDataState == 1" type="success" size="medium" style="margin-left: 10px;">审核通过</el-tag>
              <el-tag v-if="studentNewDataState == 3" type="danger" size="medium" style="margin-left: 10px;">审核未通过</el-tag>
            </el-row>
            <el-row v-if="examineRemark" style="margin-top: 10px;">
              <span style="font-weight: bold;">审核说明：</span>
              <span style="margin-left: 10px;color: #606266;">{{ examineRemark }}</span>
            </el-row>
          </div>
        </div>

        <!-- 提交按钮 -->
        <div style="text-align: center;margin-top: 30px;" v-if="attributeList.length > 0 && studentNewDataState != 1">
          <el-button type="primary" @click="submitMaterials" :loading="submitLoading">
            提交
          </el-button>
        </div>
      </div>
    </el-row>

    <!-- 预览图片弹窗 -->
    <el-dialog
      title=""
      :visible.sync="previewImgShow"
      :show-close="false"
      class="previewImg"
      width="500px"
      :before-close="handleClose">
      <img :src="$isHttp(previewImgUrl)" style="max-width: 100%;" />
      <span slot="footer" class="dialog-footer" style="display: none;">
        <el-button @click="previewImgShow = false">取 消</el-button>
        <el-button type="primary" @click="previewImgShow = false">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 签名弹窗 -->
    <singDiv
      v-if="singDivShow"
      :visible="singDivShow"
      @closeMsg="closeMsg"
      @signValue="saveSignValue">
    </singDiv>

    <!-- 裁剪弹窗 -->
    <cropper
      v-if="cropperShow"
      :initialImg="cropperImageUrl"
      :key="onDataTime"
      :isShow="cropperShow"
      @retUrl="getPropsUrl">
    </cropper>
  </div>
</template>

<script>
import { getCookieForRoleTag } from "../../common/ulit";
import filePng from '@/images/checkInMaterials/fileInfo.png';
import singDiv from "@/components/singDiv/index.vue";
import cropper from "@/components/cropper/index.vue";

export default {
  name: "MaterialUpload",
  components: {
    singDiv,
    cropper
  },
  data() {
    return {
      uploadUrl: this.$baseUrl + "/api/file/update.do", // 请求接口
      headers: {
        token: getCookieForRoleTag(),
        "_role_tag": getCookieForRoleTag() ? getCookieForRoleTag().split(".")[getCookieForRoleTag().split(".").length - 1] : null
      }, // 请求头
      attributeList: [], // 报到材料补充
      attributeRelationMap: {}, // 报到资料上传值 map
      studentConfirmStatus: 2, // 是否确认资料无误（1 是 2 否）
      studentNewDataState: 2, // 状态（1 已审核 2 未审核 3 不通过）
      examineRemark: "", // 审核备注
      previewImgShow: false,
      previewImgUrl: "",
      filePng: filePng,
      submitLoading: false,
      singDivShow: false,
      cropperShow: false,
      cropperImageUrl: "",
      onAttributeId: "",
      onDataTime: 0
    };
  },
  created() {
    this.getStudentNewData();
  },
  methods: {
    getStudentNewData() { // 获取报到材料字段以及确认状态，填写情况
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$store.dispatch("user/getStudentNewData").then((ret) => {
        loading.close();
        if (ret.code == 0) {
          this.attributeList = ret.data.attributeList || [];
          for(let i in this.attributeList){
            let attributeRelation = this.attributeList[i].attributeRelation;
            if (attributeRelation != null && !this.$isEmpty(attributeRelation.value)) {
              // 使用 Vue.set 确保响应式更新
              this.$set(this.attributeRelationMap, this.attributeList[i].attributeId, attributeRelation.value);
            } else {
                this.$set(this.attributeRelationMap, this.attributeList[i].attributeId, "");
            }
          }
          this.studentConfirmStatus = ret.data.studentConfirmStatus || 2;
          this.studentNewDataState = ret.data.studentNewDataState || 2;
          this.examineRemark = ret.data.examineRemark || "";

        } else {
          this.$message({
            message: ret.msg,
            type: 'warning'
          });
        }
      }).catch((err) => {
        loading.close();
      });
    },
    attributeSuccess(item, res, file) { // 上传成功回调
      if(res.code == 0){
        // 使用 Vue.set 确保响应式更新
        this.$set(this.attributeRelationMap, item.attributeId, res.data.url);
        this.$message({
          message: '上传成功',
          type: 'success'
        });
      } else {
        this.$message({
          message: res.msg,
          type: 'warning'
        });
      }
    },
    beforeAvatarUpload(file) { // 上传前验证
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isLt5M = file.size / 1024 / 1024 <= 5;

      if (!isJPG && !isPNG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
        return false;
      }
      if (!isLt5M) {
        this.$message.error('上传头像图片大小不能超过 5MB!');
        return false;
      }
      return (isJPG || isPNG) && isLt5M;
    },
    submitMaterials() { // 提交材料
      // 检查必填项是否都已上传
      for(let item of this.attributeList){
        if(item.notNullStatus == 1 && this.$isEmpty(this.attributeRelationMap[item.attributeId])){
          this.$message({
            message: `请上传${item.attributeName}`,
            type: 'warning'
          });
          return;
        }
      }

      // 构建提交参数
      let attributeRelationList = [];
      for (let key in this.attributeRelationMap) {
        attributeRelationList.push({
          attributeIds: key,
          value: this.attributeRelationMap[key],
        });
      }

      this.submitLoading = true;
      this.$store.dispatch("user/saveStudentNewData", { attributeRelationList: attributeRelationList }).then((ret) => {
        this.submitLoading = false;
        if (ret.code == 0) {
          this.$message({
            message: '提交成功',
            type: 'success'
          });
          this.getStudentNewData();
        } else {
          this.$message({
            message: ret.msg,
            type: 'warning'
          });
        }
      }).catch((err) => {
        this.submitLoading = false;
      });
    },
    previewImg(url) { // 预览图片
      this.previewImgUrl = url;
      this.previewImgShow = true;
    },
    handleClose(done) { // 关闭弹窗
      this.previewImgShow = false;
    },
    closeMsg() { // 关闭签名弹窗
      this.singDivShow = false;
    },
    saveSignValue(data) { // 签名的 url 地址
      // 使用 Vue.set 确保响应式更新
      this.$set(this.attributeRelationMap, this.onAttributeId, data);
      this.singDivShow = false;
    },
    singShow(url, attributeId) { // 显示签名
      this.onAttributeId = attributeId;
      this.singDivShow = true;
    },
    cropper_cj(url, attributeId) { // 裁剪图片
      this.onDataTime = new Date().getTime();
      this.cropperShow = true;
      this.cropperImageUrl = this.$isHttp(url);
      this.onAttributeId = attributeId;
    },
    getPropsUrl(data) { // 裁剪成功返回图片地址
      // 使用 Vue.set 确保响应式更新
      this.$set(this.attributeRelationMap, this.onAttributeId, data);
      this.cropperShow = false;
    }
  }
};
</script>

<style lang="less">
@import '../../styles/base.less';

.el-materialUpload {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .attrList-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .attrList_avatar {
    width: 178px;
    height: 178px;
    display: block;
    object-fit: contain;
  }

  .title_l {
    float: left;
    margin-right: 20px;
    width: 240px;
    text-align: right;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 230px;
    height: 200px;
    line-height: 200px;
    text-align: center;
  }

  .avatar {
    width: 230px;
    height: 200px;
    display: block;
  }

  .slt {
    text-align: center;
    line-height: 30px;
    color: #c5c1c1;
  }

  .title_l {
    float: left;
    margin-right: 20px;
    width: 240px;
    text-align: right;
  }

  .attrList-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 200px;
      height: 100px;
      line-height: 100px;
      text-align: center;
  }
  .attrList_avatar {
       width: 200px;
      height: 100px;
      display: block;
  }
  .previewImg{
      .el-dialog__header{
          display: none;
      }
      .el-dialog__body{
          padding: 0;
      }
      .el-dialog__footer{
          display: none;
      }
  }

  .payDialog {
      .spanTitle{
          display: inline-block;width: 75px;text-align: right;
      }
      .el-col {
          line-height: 3em;

          span {
              &.money {
                  color: red;
              }

              &:nth-child(2) {
                  margin-left: 2em;
              }
          }

          .typeBox {
              span {
                  line-height: 50px;
                  vertical-align: top;
                  display: inline-block;
              }

              img {
                  margin-left: 2em;
                  padding: 10px;
                  border: 1px solid transparent;

                  &.selected {
                      border-color: lightgrey;
                      box-shadow: 0 0 1px grey inset;
                      border-radius: 10px;
                  }

              }
          }

      }

      p.tip {
          margin-bottom: 3em;
      }

      .payInnerDialog {

      }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/MaterialUpload.vue